// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2QIAw","header":"ClearentDisclaimer_header__2Lg7p","inner":"ClearentDisclaimer_inner__1z2iv"};